import {AttrsSchema, Component} from 'panel';

import {Section, SectionItem} from 'common/components/items-menu/types';
import {SelectTheme} from 'common/components/select/constants';
import {defineAndMakeJsxFactory} from 'common/util/jsx';
import {panel2react} from 'common/util/react';

import {FilterSimpleConfig} from '../types';
import {template} from './template';

interface SimpleFilterState {
  open: boolean;
}

interface FilterBarSimpleFilterAttrs extends FilterSimpleConfig {
  name: string;
  sections: Section[];
  label: string;
  'menu-width'?: number;
  multiple?: boolean;
  'apply-button'?: string;
  theme?: string;
}
export class FilterBarSimpleFilter extends Component<SimpleFilterState, FilterBarSimpleFilterAttrs> {
  static get attrsSchema(): AttrsSchema<FilterBarSimpleFilterAttrs> {
    return {
      name: `string`,
      sections: `json`,
      label: `string`,
      'menu-width': `number`,
      multiple: `boolean`,
      'apply-button': `string`,
      theme: {type: `string`, default: `secondary`},
    };
  }

  get config() {
    return {
      template,
      defaultState: {
        open: false,
      },
      helpers: {
        getSelectAttrs: () => ({
          sections: this.attr(`sections`),
          label: this.attr(`label`),
          'menu-width': this.attr(`menu-width`),
          multiple: this.attr(`multiple`),
          theme: this.attr(`theme`) as SelectTheme,
          'selected-option': this.attr(`label`),
          elref: `filterSelect`,
          open: this.state.open,
        }),
        handleMenuChange: ({detail}) => {
          const {isOpen} = detail;
          this.update({open: isOpen});
          this.dispatchEvent(
            new CustomEvent(`menuChange`, {
              detail: {
                name: this.attr(`name`),
                isOpen,
              },
            }),
          );
        },
        handleFilterChange: ({detail}) => {
          this.dispatchEvent(
            new CustomEvent(`changeFilter`, {
              detail: {
                ...detail,
                name: this.attr(`name`),
              },
            }),
          );
        },
        handleApplyFilterClick: () => {
          this.dispatchEvent(
            new CustomEvent(`applyFilter`, {
              detail: {
                name: this.attr(`name`),
                selected: this.getSelectedItems(),
              },
            }),
          );
          this.update({open: false});
        },
      },
    };
  }

  getSelectedItems() {
    return this.getItems().filter((item) => item.isSelected);
  }

  getItems(): SectionItem[] {
    const sections = this.attr(`sections`) || [];
    return sections.map(({items}) => items).flat();
  }
}
export const FilterBarSimpleFilterEl = defineAndMakeJsxFactory(`filter-bar-simple-filter`, FilterBarSimpleFilter);
export const FilterBarSimpleFilterReact = panel2react(`filter-bar-simple-filter`, FilterBarSimpleFilter);
